/**
 * Guided tour for the Observations list view (``ObservationsPage``).
 *
 * Runs only for users with no observations yet — introduces the page so
 * they know how to log one. Users with observations see the
 * {@link combined.ts | combined tour} instead.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  filtersStep,
  listTableStep,
  newObservationStep,
  statusChartStep,
} from './steps';

export const OBSERVATIONS_LIST_TOUR_ID = 'observations.list';

registerTour({
  id: OBSERVATIONS_LIST_TOUR_ID,
  name: 'Observations',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.OBSERVATIONS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Observations',
      body:
        'Document safety, quality, and site condition findings — and ' +
        'follow them through to closure.',
    },
    newObservationStep,
    statusChartStep,
    filtersStep,
    listTableStep,
  ],
});
